import {
  Rocket, Briefcase, Compass, TrendingUp, Award, ShieldCheck,
  Fingerprint, Sparkles, Search,
} from "lucide-react";
import AudiencePageShell from "../components/AudiencePageShell";
import SeoHead from "../components/SeoHead";

export default function PourLesTalents() {
  return (
    <>
    <SeoHead
      title="Pour les talents · Révélez votre potentiel professionnel"
      description="AFRICTAL connecte talents, étudiants, diplômés, freelances et artisans africains à des opportunités vérifiées, un Passeport Numérique reconnu et un Orchestrateur IA qui accélère leur carrière partout en Afrique."
      path="/pour-les-talents"
      keywords="emploi Afrique, freelance panafricain, talents africains, passeport numérique, carrière, missions freelance"
    />
    <AudiencePageShell
      testIdRoot="afr-audience-talents"
      breadcrumb={{ label: "Talents" }}
      eyebrow="Pour les talents"
      accentColor="var(--mod-talent)"
      heroTitle={<>Révélez votre potentiel.<br /><em>Construisez votre avenir</em> avec AFRICTAL.</>}
      heroText={
        "Que vous soyez étudiant, diplômé, professionnel, freelance ou artisan, AFRICTAL vous aide à valoriser vos compétences, trouver des opportunités et développer votre carrière."
      }
      ctaPrimary={{ label: "Créer mon compte", to: "/login?mode=signup&role=talent", icon: Rocket }}
      ctaSecondary={{ label: "Découvrir les opportunités", to: "/solutions" }}

      servicesTitle="Les solutions pour les talents"
      servicesLead="AFRICTAL vous accompagne à chaque étape de votre parcours professionnel."
      services={[
        { icon: Briefcase,   title: "Trouver un emploi",              desc: "Découvrez des offres alignées avec vos compétences et vos aspirations, dans toute l'Afrique." },
        { icon: Compass,     title: "Réaliser des missions freelance", desc: "Accédez à des missions vérifiées, gérées de bout en bout avec un système de paiement sécurisé." },
        { icon: TrendingUp,  title: "Développer sa carrière",         desc: "Bénéficiez d'un accompagnement personnalisé pour progresser dans votre domaine." },
        { icon: Sparkles,    title: "Valoriser ses compétences",      desc: "Mettez en avant votre expertise et vos réalisations auprès d'employeurs et de partenaires." },
        { icon: Award,       title: "Obtenir des certifications",     desc: "Validez vos acquis grâce aux certifications reconnues par nos partenaires universitaires." },
        { icon: Fingerprint, title: "Créer son Passeport AFRICTAL",   desc: "Votre identité professionnelle vérifiable à vie — portable, souveraine, reconnue." },
        { icon: ShieldCheck, title: "Être accompagné",                desc: "Un Orchestrateur IA + une équipe humaine pour transformer votre projet en réalité." },
      ]}

      stepsTitle="Comment ça fonctionne"
      steps={[
        "Créer un compte",
        "Compléter son Passeport AFRICTAL",
        "Découvrir des opportunités",
        "Postuler ou réaliser des missions",
        "Développer sa carrière",
      ]}

      whyTitle="Bien plus qu'une plateforme d'emploi"
      whyText={
        "AFRICTAL accompagne les talents dans leur évolution professionnelle et les met en relation avec les entreprises, entrepreneurs et opportunités à travers l'Afrique. Un Passeport Numérique unique, un accompagnement personnalisé et un écosystème panafricain pour révéler tout votre potentiel."
      }

      ctaFinalTitle="Le talent est déjà en vous. AFRICTAL vous aide à le révéler."
      ctaFinalPrimary={{ label: "Créer mon compte", to: "/login?mode=signup&role=talent", icon: Rocket }}
      ctaFinalSecondary={{ label: "Découvrir AFRICTAL", to: "/solutions" }}
    />
    </>
  );
}
